import { memo } from 'react'
import { Box, Typography } from '@mui/material'
import { WELLBEING_THEME } from '../constants/wellbeingMessages'

function BreathingCircle({
	label = 'INHALE',
	prompt = 'Breathe in slowly…',
	secondsLeft = 4,
	scale = 1,
	ambient = false,
	reduceMotion = false,
}) {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: 1.5,
				my: 1,
			}}
		>
			<Typography
				sx={{
					fontSize: '0.95rem',
					fontWeight: 600,
					color: WELLBEING_THEME.muted,
					letterSpacing: '0.02em',
				}}
			>
				{prompt}
			</Typography>

			<Box
				sx={{
					position: 'relative',
					width: 168,
					height: 168,
					display: 'grid',
					placeItems: 'center',
				}}
			>
				{ambient && !reduceMotion ? (
					<Box
						aria-hidden
						sx={{
							position: 'absolute',
							inset: 8,
							borderRadius: '50%',
							bgcolor: 'rgba(91, 75, 219, 0.08)',
							animation: 'wbAmbient 6s ease-in-out infinite',
							'@keyframes wbAmbient': {
								'0%, 100%': { transform: 'scale(0.92)', opacity: 0.45 },
								'50%': { transform: 'scale(1.08)', opacity: 0.85 },
							},
						}}
					/>
				) : null}

				<svg
					width='168'
					height='168'
					viewBox='0 0 168 168'
					aria-hidden
					style={{
						position: 'absolute',
						inset: 0,
						transform: `scale(${scale})`,
						transition: reduceMotion
							? 'none'
							: 'transform 3.8s cubic-bezier(0.4, 0, 0.2, 1)',
						willChange: 'transform',
					}}
				>
					<circle
						cx='84'
						cy='84'
						r='62'
						fill='none'
						stroke={WELLBEING_THEME.ring}
						strokeWidth='2.5'
						opacity='0.9'
					/>
					<circle
						cx='84'
						cy='84'
						r='54'
						fill='rgba(238, 240, 255, 0.55)'
						stroke='rgba(91, 75, 219, 0.18)'
						strokeWidth='1'
					/>
				</svg>

				<Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
					<Typography
						sx={{
							fontSize: '0.7rem',
							fontWeight: 800,
							letterSpacing: '0.12em',
							color: WELLBEING_THEME.primary,
							mb: 0.25,
						}}
					>
						{label}
					</Typography>
					<Typography
						aria-live='polite'
						sx={{
							fontSize: '2.4rem',
							fontWeight: 600,
							color: WELLBEING_THEME.text,
							fontVariantNumeric: 'tabular-nums',
							lineHeight: 1,
						}}
					>
						{secondsLeft}
					</Typography>
				</Box>
			</Box>
		</Box>
	)
}

export default memo(BreathingCircle)
